// @ts-check

/**
 * Whether a forecast row for this group should be omitted when hideHiddenTeams is on.
 * @param {boolean | undefined} hideHiddenTeams
 * @param {{ isHidden?: boolean | null, isDeleted?: boolean | null } | null | undefined} group
 */
export const shouldHideForecastGroup = (hideHiddenTeams, group) =>
  Boolean(hideHiddenTeams && group && (group.isHidden || group.isDeleted));
